import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class usuarioConfiguracionService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/configuracion`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarSeries(data) {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/series-tipo-documento?${global.formatParameter(data)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async excel(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorModulo(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/modulo?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPermisoEstablecimiento(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/permiso-establecimiento?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPermisoAlmacen(filter) {
        const response = await axios
            .get(`${ERP}seguridad/usuario-configuracion/permiso-almacen?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}seguridad/usuario-configuracion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario-configuracion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async eliminar(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario-configuracion/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}seguridad/usuario-configuracion/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
}

export default new usuarioConfiguracionService();